import { Drawer as BaseDrawer } from '@base-ui/react/drawer'

const { Root, Portal, Description, Close, Trigger, Viewport } = BaseDrawer
export { Close, Description, Portal, Root, Trigger, Viewport }

export { Backdrop } from './backdrop'
export { Content } from './content'
export { Footer } from './footer'
export { Header } from './header'
export { Popup } from './popup'
export { SwipeArea } from './swipe-area'
export { Title } from './title'
